import { TopRankIcon } from '@terminal/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import React from 'react';

import styles from './RankSection.module.scss';

export const RankSection = ({
  title,
  label,
  rank,
}: {
  title: string;
  label: string;
  rank: number;
}) => {
  return (
    <div className={styles.sectionRow}>
      <div className={styles.titleBase}>{title}</div>
      <div className={styles.styledRankWrapper}>
        <div className={styles.rankContainer}>
          <div className={styles.rankLabel}>{label}</div>
          <div className={styles.rankFlexRow}>
            <TopRankIcon rank={rank} />
          </div>
        </div>
      </div>
    </div>
  );
};
